import { ProjectDemoData } from './types';
import { extractNthItem } from './director-engine';

// Project B：AI项目
// 数据来源与口径：
// 1. 产品/方向/母题/合规知识：项目信息/AI项目.md + AI项目-素材分析报告.md
// 2. 投放数据（已脱敏，金额×0.1）：
//    - 月度趋势：AI项目整体复盘汇报（2025-11 ~ 2026-08 真实月度），2026-09(1-10日)为演示推演
//    - 标签/形式/素材明细：AI项目-2.csv（2026-07 快手测试账户组真实明细锚点月）
//    - 比率指标（激活成本/留存率/CTR）保持真实趋势
export const projectB: ProjectDemoData = {
  id: 'qianwen',
  name: 'AI项目',
  category: 'AI生活助手',
  initType: 'HISTORICAL_DATA',
  currentStage: '内容方向测试期（100条头部素材学习推进中）',
  businessObjective: '把AI能力落进真实生活任务，提升激活规模与留存复用',
  targetMedia: '快手信息流（测试账户组）+ 全账户复盘口径',

  // AI拆解页「分析数据概览」（DEMO 展示数据，量级与素材学习规模对应）
  analysisStats: {
    hitMaterialCount: 326,
    analyzedMaterialCount: 5248,
    dataStartDate: '2026-03-01',
    dataEndDate: '2026-09-15',
    lastUpdatedAt: '2026-09-15 09:20',
  },

  productUnderstanding: {
    targetAudience: '生活场景中有具体任务需求的用户（31-40岁为当前效率核心人群）',
    coreSellingPoints: [
      '基于AI项目大模型的AI生活助手',
      '对话即可完成点餐、打车、购物、机票酒店预订等任务',
      '覆盖健身养生、情感陪伴、旅游、宠物等八大生活方向',
      '输入条件 → AI项目处理 → 可执行结果的任务闭环'
    ],
    mainScenarios: [
      '健身养生（动作分析、计划生成）',
      '情感陪伴（沟通改写、陪练）',
      '旅游（路线规划、讲解）',
      '宠物（观察清单、训练步骤）',
      '闪购外卖（条件筛选、订单草案）',
      '高德打车（目的地核对、路线）',
      '生活技能（识图、分步指导）'
    ],
    decisionPath: [
      '观看者：生活中遇到具体任务的用户（看不懂、不会选、来不及、怕做错）',
      '触发：此刻正在做的任务——点外卖、叫车、填志愿、做饭、带宠物',
      '使用：对话输入 → AI项目处理 → 可执行结果（必须展示至少两个环节）',
      '转化：下载激活 → 关键行为 → 次日/7日留存复用（记录、追问、提醒、续讲）'
    ],
    currentStrategy: '优先从生活任务切入；对话+生活方向约60%，达人原生感优先验证；强钩子必须接到「下一次还会用」的复用理由'
  },

  learningWorkflow: {
    brief: {
      businessObjective: '把AI能力落进真实生活任务，提升激活规模与留存复用',
      currentStage: '内容方向测试期（100条头部素材学习推进中）',
      targetMedia: '快手信息流（测试账户组）+ 全账户复盘口径',
      targetAudience: '31-50岁为主要规模区间；31-40岁关键行为成本最优（63.81元）；50岁以上规模最大但需大字慢步骤',
      keySellingPoints: [
        '对话完成生活任务：点餐、打车、购物、订票',
        '覆盖学习、办公、健康等生活领域',
        '任务式承接：输入条件 → AI项目处理 → 可执行结果'
      ],
      forbiddenDirections: '功能以投放当日、目标地区、目标端实测为准；不得把候选假设写成"已验证跑量规律"；不承诺减重/诊断/预测准确',
      currentProblems: '激活成本38.61元高于28-35元目标；次日留存17.60%低于18%-20%目标；缺「二次使用任务」设计',
      costTarget: '激活成本回到28-35元目标区间',
      volumeTarget: '次留回到18%-20%目标区间',
      specialRequirements: 'Android占96.7%需优先实机验证；动态字段（商家/票价/赛程）投放前必须核验'
    },
    materialLearning: {
      videoCount: 9,
      sections: [
        {
          title: '现有素材样本的形式分布',
          items: [
            '达人二创：宠物乱尿、深蹲分析、博物馆讲解、情感安慰等（原生感强）',
            '实拍口播：帮父母打车、生活技能洗菜粘锅（操作演示清楚）',
            '实拍情景剧：跟AI项目学做饭、礼物选择（关系冲突带出任务）',
            '数字人+混剪：世界杯赛前信息（时效快，需版权与失效管理）'
          ]
        },
        {
          title: '五条历史重点素材的教训（复盘口径，金额已脱敏）',
          items: [
            '体脂率公式：问题真实、激活成本31.17元好，但CTR 0.29%、次留14.12%——算一次没有再打开的理由',
            '性别转换生图：次留12.23%最低，一次转换后没有稳定的下一步',
            '语音哄睡：方言有记忆点，但单次故事不构成第二天打开的理由',
            '向日葵飞花：画面漂亮但用途弱，激活成本41.67元高于整体',
            '拍题答疑：CTR 0.90%最高但关键行为成本81.44元最差——名校标签强于功能本身'
          ]
        },
        {
          title: '结构性结论',
          items: [
            '强钩子能带来点击或激活，但次留取决于「用户是否知道下一次什么时刻还要打开」',
            '产品需要以「输入条件 → AI项目处理 → 可执行结果」证明，不能只秀神奇答案',
            '达人线历史更优（激活37.45元/次留18.57%），但必须通过授权素材和单变量持续复测',
            '上下滑资源位占花费98.2%，是规模主阵地'
          ]
        }
      ],
      recommendations: [
        '优先从生活任务切入：看不懂、不会选、来不及、怕做错、想找人商量',
        '达人原生感优先验证，但不据此停掉自制测试',
        '每条素材必须设计「下一次为何还会用」的连续任务'
      ]
    },
    strategySummary: [
      '优先从生活任务切入，把「第一次问」接到「下一次还会问」',
      '对话+生活方向约60%，其他功能方向各10%-20%，另留10%探索（历史复盘口径）',
      '达人原生感优先验证：达人线次留18.57%优于自制线16.16%（历史复盘）',
      '31-40岁是当前效率核心（关键行为成本63.81元），31-50岁做规模主力',
      '候选假设不得写成已验证跑量规律：100条头部素材学习完成前不放大预算'
    ]
  },

  optimization: {
    overview: {
      periodLabel: '2025-11-01 ~ 2026-09-10',
      platform: '全账户（星广联投/快手等，复盘口径）',
      conversionLabel: '激活成本',
      totalSpend: 1896103.06,
      conversions: 49400,
      costPerConversion: 38.38,
      ctrPct: 1.02
    },
    monthly: [
      { month: '2025-11', spend: 60326.08, conversions: 1748, costPerConversion: 34.51, retentionPct: 18.72 },
      { month: '2025-12', spend: 304480.65, conversions: 8699, costPerConversion: 35, retentionPct: 23.2 },
      { month: '2026-01', spend: 366851.16, conversions: 9069, costPerConversion: 40.45, retentionPct: 20.0 },
      { month: '2026-02', spend: 186073.61, conversions: 5326, costPerConversion: 34.94, retentionPct: 23.3 },
      { month: '2026-03', spend: 196575.39, conversions: 5365, costPerConversion: 36.64, retentionPct: 13.1 },
      { month: '2026-04', spend: 317911.58, conversions: 7133, costPerConversion: 44.57, retentionPct: 12.9 },
      { month: '2026-05', spend: 233800.11, conversions: 5742, costPerConversion: 40.72, retentionPct: 13.0 },
      { month: '2026-06', spend: 82866.27, conversions: 2071, costPerConversion: 40.01, retentionPct: 13.8 },
      { month: '2026-07', spend: 61427.35, conversions: 1922, costPerConversion: 31.96, retentionPct: 16.67 },
      { month: '2026-08', spend: 64563.65, conversions: 1744, costPerConversion: 37.02, retentionPct: 16.3 },
      { month: '2026-09(1-10日)', spend: 21227.21, conversions: 581, costPerConversion: 36.54, retentionPct: 16.5 }
    ],
    tagStats: [
      { label: '快手原创素材', materialCount: 6, spend: 368.63, spendSharePct: 1.4, costPerConversion: 33.51, note: '原创判定素材，成本优于整体' },
      { label: '快手非低质素材', materialCount: 8, spend: 337.23, spendSharePct: 1.3, costPerConversion: 42.15 },
      { label: '快手重复素材', materialCount: 5, spend: 333.37, spendSharePct: 1.3, costPerConversion: 41.67, note: '重复上传无增量效率，建议下线' },
      { label: '未打标签', materialCount: 79, spend: 24554.48, spendSharePct: 95.9, costPerConversion: 36.27 }
    ],
    dimensions: [
      { group: '投放线', name: '自制线（常规-自制）', spend: 22597.16, spendSharePct: 88.3, costPerConversion: 36.21 },
      { group: '投放线', name: '达人线（助推-达人）', spend: 2996.99, spendSharePct: 11.7, costPerConversion: 37.94 },
      { group: '内容方向', name: 'AI对话', spend: 11337.55, spendSharePct: 44.3, costPerConversion: 35.88 },
      { group: '内容方向', name: '学习chat', spend: 4490.66, spendSharePct: 17.5, costPerConversion: 36.81 },
      { group: '内容方向', name: '高考频道', spend: 3061.01, spendSharePct: 12.0, costPerConversion: 34.78 },
      { group: '内容方向', name: '高考问答', spend: 2364.65, spendSharePct: 9.4, costPerConversion: 40.08 },
      { group: '内容方向', name: '视频通话', spend: 1975.62, spendSharePct: 7.7, costPerConversion: 36.59 },
      { group: '内容方向', name: '高德打车（权益）', spend: 1108.98, spendSharePct: 4.3, costPerConversion: 32.62 }
    ],
    topMaterials: [
      { name: '世界杯·赛事场景混剪（达人二创）', spend: 6477.27, conversions: 181, costPerConversion: 35.79, ctrPct: 0.13, cvrPct: 18.54 },
      { name: '高考志愿·达人授权系列-01（系统迷授权）', spend: 3201.14, conversions: 65, costPerConversion: 49.25, ctrPct: 0.25, cvrPct: 6.35 },
      { name: '教育/K12·AI项目小讲堂（达人二创）', spend: 1236.76, conversions: 28, costPerConversion: 44.17, ctrPct: 0.24, cvrPct: 5.04 },
      { name: '育儿·对话陪伴（达人二创）', spend: 1230.51, conversions: 34, costPerConversion: 36.19, ctrPct: 0.34, cvrPct: 2.98 },
      { name: '美妆护肤·对话答疑（达人二创）', spend: 1171.26, conversions: 20, costPerConversion: 58.56, ctrPct: 0.16, cvrPct: 4.36 },
      { name: '高考志愿·达人授权系列-02（圆脸姿姿授权）', spend: 779.83, conversions: 30, costPerConversion: 25.99, ctrPct: 0.44, cvrPct: 7.65 }
    ],
    bestCpaMaterials: [
      { name: '学习·作业批改（达人授权）', spend: 511.46, conversions: 20, costPerConversion: 25.57, ctrPct: 0.67, cvrPct: 4.73 },
      { name: '高考志愿·达人授权系列-02（圆脸姿姿授权）', spend: 779.83, conversions: 30, costPerConversion: 25.99, ctrPct: 0.44, cvrPct: 7.65 },
      { name: '情感陪伴·对话开口-01（美甲配色）', spend: 678.59, conversions: 26, costPerConversion: 26.1, ctrPct: 0.28, cvrPct: 12.74 },
      { name: '高考志愿·家庭情景（当你有个自以为是的妈妈）', spend: 492.22, conversions: 18, costPerConversion: 27.35, ctrPct: 0.71, cvrPct: 4.79 },
      { name: '高德打车·对话叫车（达人二创）', spend: 643.35, conversions: 23, costPerConversion: 27.97, ctrPct: 0.15, cvrPct: 26.59 }
    ],
    effectiveDirections: [
      '世界杯时效混剪：单条消耗6477.27、181个激活，CVR 18.54%，当期规模与效率双优（注意版权与失效管理）',
      '高考频道投放方向：激活成本34.78，低于整体8.4%',
      '对话类达人二创（作业批改/情感陪伴/高德打车）：激活成本25.57~27.97，为当期成本最优集群',
      '自制线承接规模：88.3%消耗、激活成本36.21，稳定盘',
      '历史复盘：达人线次留18.57%优于自制线16.16%，达人原生感值得优先验证'
    ],
    weakDirections: [
      '美妆护肤方向：激活成本58.56，比整体高52.6%，暂停并复盘素材',
      '高考问答方向：激活成本40.08，建议并入高考频道统一运营',
      '快手重复素材：重复上传无增量效率（CPA 41.67），下线',
      '历史教训（复盘口径）：3-6月留存跌到13%左右——只用一次性猎奇钩子、产品进入过晚都会让激活与次留脱钩'
    ],
    nextRoundPlan: [
      '方向配比：对话+生活方向约60%，其他功能方向各10%-20%，另留10%探索',
      '达人原生感优先测试：补达人二创授权小样，用单变量验证「原生感→次留」的传导',
      '世界杯为强时效方向：每条素材记录信息截止时间与自动失效时间，非赛事窗口转足球知识长期主题',
      '50岁以上人群用「帮父母/本人办事」的大字慢步骤演示，弱化技术术语',
      '按漏斗诊断：曝光看3秒率、承接看5秒/完播、行动看CTR/激活、留存看次留/7留，不只看消耗'
    ],
    historyNote: '历史复盘底座（2025-11 ~ 2026-08，全账户口径，金额与数量已脱敏）：总花费191.43万；激活成本38.61元；关键行为成本66.22元；次日留存17.60%；7日留存8.48%；点击率1.02%；关键行为率58.31%。其中达人线花费110.94万、激活成本37.45元、次留18.57%；自制线花费80.49万、激活成本40.35元、次留16.16%。31-40岁关键行为成本63.81元最优，50岁以上85.02元。',
    dataSourceNote: '数据来源：AI项目整体复盘汇报（2025-11~2026-08真实月度）+ AI项目-2.csv快手测试账户组明细（2026-07锚点月）。金额已脱敏（×0.1），比率指标保持真实趋势。月度表为全账户复盘口径，标签/形式/素材明细为快手测试组当期口径。'
  },

  productSkill: {
    facts: [
      {
        category: '产品定位',
        key: 'positioning',
        value: '基于AI项目大模型、融合阿里生态及第三方合作伙伴的AI助手，可通过对话完成点餐、打车、购物、机票酒店预订等任务（官方快照核验日：2026-09-10）'
      },
      {
        category: '能力边界',
        key: 'capability_boundary',
        value: '部分办事能力处在分阶段公测和持续扩展中；内容必须把「能办事」翻译成具体任务，不能喊绝对能力口号'
      },
      {
        category: '动态字段',
        key: 'dynamic_fields',
        value: '外卖商家/价格/优惠、打车城市/车型/预估价、景点开放/票价、赛事日期/阵容均为动态信息，投放前必须以当期真实录屏核验'
      },
      {
        category: '历史规模',
        key: 'history_scale',
        value: '2025-11 ~ 2026-08 全账户总花费191.43万（脱敏后），上下滑资源位占98.2%，Android端占96.7%'
      }
    ],
    compliance: [
      {
        ruleType: 'REQUIRED',
        content: '所有功能以投放当日、目标地区、目标端和用户实际界面为准，上线前实机核验',
        severity: 'HIGH'
      },
      {
        ruleType: 'FORBIDDEN',
        content: '不得把候选假设写成"已验证跑量规律"（证据等级A/B/C/D管理）',
        severity: 'HIGH'
      },
      {
        ruleType: 'FORBIDDEN',
        content: '健身不诊断不承诺减重；宠物不做诊疗用药；世界杯不碰博彩赔率；打车不保证时效价格',
        severity: 'HIGH'
      },
      {
        ruleType: 'FORBIDDEN',
        content: '不伪造专家/记者/官方身份；不使用未授权达人原声、影视赛事画面',
        severity: 'HIGH'
      }
    ],
    audienceSegments: [
      {
        segmentName: '31-40岁效率核心人群',
        description: '当前关键行为成本最优（63.81元），历史花费457.27万（脱敏前口径最大效率池）',
        coreNeed: '健康、家庭、出行、生活效率类真实任务',
        painPoint: '信息多、步骤杂、时间紧',
        trigger: '体检后、点餐时、出行前、加班夜晚',
        concern: '能不能真的帮我少想一步'
      },
      {
        segmentName: '50岁以上生活用户',
        description: '规模最大（花费525.19万，脱敏前口径）但关键行为成本85.02元偏弱',
        coreNeed: '帮父母/本人办事：大字、慢步骤、先说风险',
        painPoint: '字小、术语多、怕点错、怕被骗',
        trigger: '手机操作、办事流程、家电使用',
        concern: '会不会把我引导去乱扣费'
      },
      {
        segmentName: '独居青年/社交焦虑人群',
        description: '情感陪伴方向核心人群',
        coreNeed: '一句准确接住情绪的话、可直接说出口的表达',
        painPoint: '没人商量、不知道怎么开口',
        trigger: '深夜回家、争吵冷战、聚会相亲前',
        concern: '会不会只是话术套路'
      },
      {
        segmentName: '新手宠主/厨房新手',
        description: '宠物与生活技能方向核心人群，高频小问题密集',
        coreNeed: '眼前问题立即解决 + 下次还会用的连续任务',
        painPoint: '小问题不想求人、一失败就放弃',
        trigger: '猫乱尿、锅粘了、菜不知道怎么洗',
        concern: '是不是网上抄的偏方'
      }
    ],
    needsAndPainPoints: [
      {
        audienceSegment: '31-40岁效率核心人群',
        need: '把多处查询变成一个可执行结果',
        painPoint: '要在几个App之间反复切换比价、查路线、做计划',
        trigger: '周五想短途游、午餐选择困难、临时出差',
        concern: 'AI给的是不是泛泛而谈'
      },
      {
        audienceSegment: '50岁以上生活用户',
        need: '慢步骤、大字体、先说风险的操作引导',
        painPoint: '界面复杂、验证码/支付环节容易被骗',
        trigger: '帮父母叫车、手机提示看不懂',
        concern: '点错了怎么办'
      },
      {
        audienceSegment: '独居青年/社交焦虑人群',
        need: '辅助表达和陪练，不替用户做重大决定',
        painPoint: '情绪没人接住，话到嘴边说不对',
        trigger: '吵架后、深夜、重要对话前',
        concern: '会不会养成情感依赖'
      }
    ],
    scenarios: [
      {
        name: '厨房救场',
        description: '做饭过程中锅开始粘、菜太咸',
        userContext: '厨房新手第一次做菜失败瞬间',
        productEntrance: '拍一下锅/问一句，AI项目给分步补救和安全边界'
      },
      {
        name: '办公室午餐',
        description: '6个人3种忌口，中午不知道吃什么',
        userContext: '选择疲劳+时间紧',
        productEntrance: '一句话说清人数预算忌口，生成订单草案，下单前用户确认'
      },
      {
        name: '帮父母打车',
        description: '父母只说「去老地方」，地址说不清',
        userContext: '子女远程帮父母安排出行',
        productEntrance: '核对目的地/上车点，生成给父母的提醒消息，需用户授权'
      },
      {
        name: '深夜睡前',
        description: '独居青年想有人听自己讲完今天',
        userContext: '情绪需要出口，不想打扰朋友',
        productEntrance: '倾听、追问、睡前内容；明晚可以续讲（复用理由）'
      }
    ],
    benefitMessages: [
      {
        audienceSegment: '31-40岁效率核心人群',
        benefit: '一句话生成两天路线/订单草案/训练计划',
        messagingAngle: '替你少想一步、少查几处、少切几个App',
        productPlacement: '展示输入条件和结果两个环节，结尾给复用理由'
      },
      {
        audienceSegment: '50岁以上生活用户',
        benefit: '大字慢步骤，帮父母把事办明白',
        messagingAngle: '不是取代你操作，是陪着你把每一步看清楚',
        productPlacement: '真实录屏演示，支付/授权步骤保留并提示确认'
      },
      {
        audienceSegment: '新手宠主/厨房新手',
        benefit: '拍一下就能问，分步指导+观察清单',
        messagingAngle: '先排环境再看行为，安全边界说清楚',
        productPlacement: '非诊疗声明 + 「下次遇到这种情况还可以这样问」'
      }
    ],
    creativeRecommendations: [
      {
        name: '宠物·乱尿问题排查（达人二创）',
        character: '新手猫主人',
        characterRelationship: '第一人称养宠日常',
        scene: '家中猫砂盆旁，真实小猫画面',
        hook: '猫突然不用猫砂盆，先别急着骂它',
        contentFormat: '达人二创+对话卡片',
        storyDirection: '真实问题 → AI项目追问环境变化 → 生成观察清单 → 「非诊疗，持续异常就医」',
        visualStyle: '原生宠物画面开场，UI卡片承接',
        description: '萌宠原生画面有天然停留；补「时间线记录—环境排查—就诊清单」的复用任务'
      },
      {
        name: '高德打车·帮父母去博物馆（实拍口播）',
        character: '在外工作的子女',
        characterRelationship: '第一人称家庭照护',
        scene: '桌前真实操作录屏',
        hook: '爸妈只说「去老地方」，怎么帮他们把车叫明白',
        contentFormat: '实拍口播+真实UI',
        storyDirection: '核对目的地 → 选择上车点 → 生成给父母的提醒消息 → 授权确认',
        visualStyle: '手部操作+屏幕特写，步骤字幕',
        description: '家庭照护代入感强，操作可演示；强调授权与确认，不承诺时效价格'
      },
      {
        name: '世界杯·60秒看懂本场（数字人+混剪）',
        character: '数字人主持',
        characterRelationship: '信息讲解者（不伪造专家记者身份）',
        scene: '带日期的问题开场+赛事信息卡',
        hook: '今晚的比赛，60秒看懂为什么值得看',
        contentFormat: '数字人口播+授权赛事画面混剪',
        storyDirection: '带时间戳的信息拆解 → 来源与条件 → 观赛清单 → 设置提醒（复用）',
        visualStyle: '信息卡统一模板，版权画面替代方案',
        description: '时效更新快，可模板化；必须标注信息截止时间和自动失效时间，不碰博彩'
      }
    ],
    complianceRules: [
      '功能以投放当日、目标地区、目标端实测为准，动态信息上线前核验',
      '候选假设不得写成已验证跑量规律',
      '健身养生：不诊断、不承诺减重，疼痛/慢病引导专业意见',
      '情感陪伴：不鼓励依赖、不替代现实关系，危机信号转现实支持',
      '世界杯：赛程/比分/规则当期核验，无版权画面不用，无博彩引导',
      '闪购/打车：商家价格库存运力均为动态信息，支付前保留用户确认',
      '生活技能：不指导带电拆机、燃气风险、危险化学品混合',
      '不伪造专家/记者/官方身份；达人原声、影视赛事画面必须授权'
    ]
  },

  director: {
    optimization: {
      quickPrompts: [
        '最近什么素材表现最好？',
        '哪类素材跑量能力最强？',
        '自制和达人表现有什么差异？',
        '哪个方向激活成本最低？',
        '最近素材应该重点做什么？',
        '有哪些方向建议减少？'
      ],
      mockResponses: [
        {
          keywords: ['表现最好', '最好'],
          response: (project, _conversation) => {
            return `基于「${project.name}」投放数据（金额与数量已脱敏）：

【结论】
当期测试组表现最好的是世界杯时效混剪；放到历史复盘看，「有效起点」和「留存承接」要分开评判。

【数据依据】
- 世界杯·赛事场景混剪（达人二创）：消耗 6477.27，181个激活，激活成本 35.79，转化率 18.54%——当期规模与效率双优
- 成本最优：学习·作业批改（达人授权）激活成本 25.57；高考志愿系列-02 25.99；情感对话-01 26.10
- 历史五条重点素材（复盘口径）：体脂率公式激活成本 31.17元 最好，但次留 14.12% 都低于目标——能拉新不等于能留下

【判断】
1. 世界杯素材赢在「强时效+混剪节奏+复用理由（赛前提醒）」，但这类素材受版权和失效时间约束
2. 对话类达人二创是成本最优集群（25~28元），说明「真实问题+可执行结果」的结构效率高

【下一轮建议】
1. 世界杯继续投但每条标注信息截止时间与自动失效时间
2. 对话类达人二创扩小样：作业批改/情感开口/打车核对各做单变量版本`;
          }
        },
        {
          keywords: ['跑量'],
          response: (project, _conversation) => {
            return `基于「${project.name}」当期测试组数据（金额与数量已脱敏）：

【结论】
当期跑量主力是 AI对话方向（占 44.3%）和世界杯/高考志愿两大主题素材。

【数据依据】
- 内容方向消耗占比：AI对话 44.3%（激活成本35.88）> 学习chat 17.5%（36.81）> 高考频道 12.0%（34.78）> 高考问答 9.4%（40.08）> 视频通话 7.7%
- 单条Top1：世界杯混剪 6477.27（占当期约25%）
- 高考志愿达人授权系列两条合计消耗约 3981

【判断】
1. AI对话方向是当前测试组的规模基本盘，成本贴近整体均值
2. 高考是季节性主题（志愿填报窗口），高考频道（34.78）效率优于高考问答（40.08），同主题两个账号组的运营质量有差异

【下一轮建议】
1. AI对话方向继续做规模盘，素材按「细分人群×触发时刻」拆而不是按功能拆
2. 高考问答并入高考频道统一运营
3. 世界杯强时效素材建立「赛前/赛后模板」，重投前重录动态卡片`;
          }
        },
        {
          keywords: ['自制', '达人'],
          response: (project, _conversation) => {
            return `基于「${project.name}」投放数据（金额与数量已脱敏）：

【结论】
当期自制线承接了 88.3% 的消耗且成本更优；但历史复盘口径下达人线的留存更好——两个口径要一起看。

【数据依据】
- 当期测试组：自制线 88.3%（激活成本 36.21）vs 达人线 11.7%（37.94）
- 历史复盘（2025-11~2026-08）：达人线花费 110.94万、激活成本 37.45元、次日留存 18.57%；自制线 80.49万、40.35元、16.16%

【判断】
1. 当期达人线占比小、还在测试期，成本略高是起量期的正常现象
2. 历史数据支持「达人原生感优先测试」：达人线次留高 2.4 个百分点，说明原生人设对复用有价值
3. 但复盘同样提醒：达人线较优不等于自制线不需要——自制承担规模和稳定盘

【下一轮建议】
1. 补达人二创授权小样，用单变量验证「原生感→次留」的传导是否成立
2. 自制线维持规模，重点把「复用理由」写进脚本（记录/提醒/续讲）`;
          }
        },
        {
          keywords: ['激活成本', '成本最低', '最低'],
          response: (project, _conversation) => {
            return `基于「${project.name}」投放数据（金额与数量已脱敏），激活成本最优的方向和素材：

【数据依据】
- 内容方向：高德打车（权益）32.62 < 高考频道 34.78 < AI对话 35.88 < 视频通话 36.59 < 学习chat 36.81 < 高考问答 40.08
- 素材级（消耗≥400）：作业批改 25.57 / 高考志愿-02 25.99 / 情感对话-01 26.10 / 高考家庭情景 27.35 / 高德打车对话 27.97
- 历史复盘人群口径：31-40岁关键行为成本 63.81元 最优；50岁以上 85.02元 最弱

【判断】
1. 成本最优集群的共同点：真实生活问题 + 达人原生 + 对话可执行结果（高德打车那条转化率 26.59% 极高）
2. 50岁以上人群规模最大但后链路弱，不是砍掉，而是换表达：大字慢步骤、帮父母办事场景

【下一轮建议】
1. 把「对话类达人二创」定为成本基准线（25~28元），新素材先对标
2. 50+人群素材弱化技术术语，用生活任务演示`;
          }
        },
        {
          keywords: ['重点', '下一轮', '分配'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解 和复盘结论，下一轮重点：

【结论】
方向上「对话+生活约60%」，素材上每个都补「复用理由」，形式上达人原生感优先验证。

【数据依据】
- 历史复盘：激活成本38.61元（目标28-35）、次留17.60%（目标18-20）、7留8.48%——缺口在留存不在拉新
- 五条重点素材共性：有钩子没复用，体脂率算完、故事听完就没有下一步
- 当期成本最优素材（25~28元）全部是对话类达人二创

【下一轮建议】（内容资源分配）
1. 对话与生活方向约60%：健身养生/情感陪伴/生活技能/宠物/闪购/打车
2. 其他功能方向各10%-20%，另留10%探索（世界杯等时效主题从这里出）
3. 每条素材必须回答「用户下一次为什么还要打开」：体脂率接饮食记录、哄睡接明日续讲、生视频接节日发布
4. 100条头部素材学习完成前不放大预算，新组合标记「候选/待测试」`;
          }
        },
        {
          keywords: ['减少', '弱'],
          response: (project, _conversation) => {
            return `基于「${project.name}」投放数据（金额与数量已脱敏），建议减少或停止的方向：

【数据依据】
1. 美妆护肤方向：激活成本 58.56，比整体 38.38 高 52.6%
2. 高考问答：激活成本 40.08，比同主题的高考频道（34.78）差 15%
3. 快手重复素材：CPA 41.67，重复上传没有增量效率
4. 历史教训（复盘口径）：4月花费 31.70万（脱敏后）但激活成本 44.57、次留 12.9% 同步恶化——用继续加量代替素材迭代的结果

【判断】
1. 美妆护肤的「AI项目帮我完成XX」任务没有击中真实痛点，人群与功能的匹配需要重做
2. 高考两个账户组的差异说明同方向不同运营质量的结果差异，先并组再谈方向好坏

【下一轮建议】
1. 美妆护肤暂停，复盘「人群-触发时刻-任务」错在哪
2. 高考问答并入高考频道
3. 重复素材下线，建立素材去重检查
4. 任何方向成本恶化时，先迭代素材而不是加预算`;
          }
        }
      ],
      fallbackResponse: '我理解你的问题。优化助手当前预置了投放数据相关的常见问题（基于AI项目复盘与快手测试组脱敏数据）。你可以试试快捷问题，或切换到「保险项目」查看完整演示。'
    },
    planning: {
      quickPrompts: [
        '给我素材方向',
        '给我选题',
        '给我设计演员和人物关系',
        '给我场景方向',
        '给我写实拍情景剧',
        '给我写口播',
        '给我写AI剧情（数字人）',
        '帮我写完整脚本'
      ],
      mockResponses: [
        {
          keywords: ['素材方向', '方向'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，八大内容方向按优先关系给你建议：

## 第一优先：对话与生活方向（复盘确认的留存优先）
1. **情感陪伴**：把「不知如何表达」转成一句能说出口的话。人群：独居青年/恋爱沟通困难/礼物选择困难。首要任务：沟通改写、陪练、话题生成
2. **生活技能**：用「此刻正在做」的问题建立高频复用。人群：独居/租房/厨房新手/50+。首要任务：识图、分步指导、清单
3. **闪购外卖 / 高德打车**：当下选择压力里替用户少想一步。首要任务：条件筛选、目的地核对、订单草案

## 第二优先：高频生活内容方向
4. **健身养生**：把健康焦虑转成可执行日常记录（不诊断不承诺减重）
5. **宠物**：用观察和清单减轻照护焦虑（不做诊疗用药）
6. **旅游**：把多处查询变成同行人可执行的路线（动态信息当期核验）

## 时效方向（从10%探索池出）
7. **世界杯**：及时而克制的信息降低观赛门槛（版权+失效管理+不碰博彩）

## 使用原则
- 每个方向按「细分人群 → 触发时刻 → 显性痛点 → 情绪痛点 → 决策障碍 → 吸引机制 → AI项目任务」逐层拆解
- 一条素材只服务一个主要人群、一个主要时刻、一个主要问题、一个主要任务
- 方向配比参考：对话+生活约60%，其他各10%-20%，留10%探索

需要具体选题就说「给我选题」，需要人物设计就说「给我设计演员和人物关系」。`;
          }
        },
        {
          keywords: ['选题'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解（160个内容母题库），当前值得优先测试的选题：

## 情感陪伴（复盘优先方向）
1. QG001 恋爱争吵：女友说「没事」，下一句怎么回（达人二创）
2. QG004 礼物选择：预算300元、交往半年，礼物怎么筛（实拍情景剧）
3. QG015 想家时刻：把一句「我挺好的」改成想发给父母的话（达人二创）

## 生活技能（高频复用）
4. SH001 厨房新手：锅开始粘了，先别急着加油（实拍口播）
5. SH003 冰箱剩菜：拍三样剩余食材，生成一顿饭（实拍情景剧）
6. SH016 50岁以上：手机提示看不懂，先判断能不能点（实拍口播）

## 高德打车（当期成本最优方向之一）
7. GD001 帮父母叫车：父母只说「去老地方」，怎么确认目的地（实拍情景剧）
8. GD002 父母出行：去博物馆叫车前核对这4项（实拍口播）

## 宠物 / 健身 / 世界杯
9. CW002 乱尿问题：猫砂盆不用，先排这4类原因（达人二创）
10. JY004 久坐上班族：下午肩颈紧，工位边能做什么（达人二创）
11. SJ001 轻度球迷：60秒看懂本场为什么值得看（数字人）

## 选题原则
一条素材 = 一个主要人群 + 一个主要时刻 + 一个主要问题 + 一个主要任务；输出前3秒钩子、剧情结构、AI项目进入点、功能证明、复用理由、CTA和唯一测试变量。

想展开哪一条，直接说「展开第N个」。`;
          }
        },
        {
          keywords: ['演员', '人物'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，五类一级素材的角色设计原则：

## 1. 达人二创（真实的人在真实场景）
- **角色**：真实达人本人，保留其口语习惯和人设，不伪造达人体验
- **关系**：达人 + AI项目对话（屏幕/语音）
- **边界**：必须取得授权；不照搬脸、原声、完整脚本；不得搬运未授权画面

## 2. 数字人（信息讲解者）
- **角色**：清晰的口播主持形象，不伪造专家、记者、官方、球员身份
- **适合**：世界杯时效解读、清单解释、路线方案
- **边界**：不承担强情绪陪伴；信息必须带来源和日期

## 3. 实拍情景剧（关系冲突）
- **角色组合**：情侣/母女/合租室友/亲子/同事
- **结构**：角色冲突 → 一个问题 → AI项目输入 → 结果推动剧情 → 行动
- **边界**：一条只保留一个核心冲突；不演得脱离真实任务

## 4. 实拍口播（操作演示者）
- **角色**：真实用户/子女/50+本人
- **适合**：打车操作、生活技能、健身计划、父母使用教学
- **边界**：不堆术语、不把个人体验包装成普遍承诺

## 5. 混剪（多画面叙事）
- **角色**：无固定角色，以结果/反差/多画面快切叙事
- **边界**：音乐、体育、影视、图片均需授权；镜头来源必须可追溯

## 50+人群专属注意
角色用「帮父母/本人办事」场景，大字慢步骤，先说风险，弱化技术术语。`;
          }
        },
        {
          keywords: ['场景'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，八大方向的高频场景库：

## 健身养生
健身房/工位/居家客厅——首屏优先出现真实动作、餐盘、时间或具体问题，不先讲「AI很强」

## 情感陪伴
深夜卧室/下班路上/约会前——钩子先出现关系事件和真实台词，例如「她只回了一个嗯，我该怎么接」

## 世界杯
赛前聚会/办公室讨论/深夜观赛——信息必须带赛事名称、比赛时间、信息截止时间

## 旅游
周五晚的高铁站/博物馆展厅/自驾车内——从同行人、天数、预算切入，不从「十大景点」开始

## 宠物
猫砂盆旁/遛狗路上/宠物医院门口——首屏用真实宠物动作呈现具体问题

## 闪购外卖
办公室工位（11:30）/深夜加班桌前/冰箱前——从「当下要吃什么」的具体任务切入

## 高德打车
高铁站出口/医院门口/雨夜路边——情绪入口用「帮父母、赶时间、陌生地」等明确出行压力

## 生活技能
厨房灶台/洗衣间/出租屋——优先选择用户此刻正在做的任务，画面保留真实失败和结果

## 通用规则
所有涉及交易、路线、票务、赛程的画面必须用投放当期真实录屏，用户确认、支付、定位、授权步骤不能省略或伪造。`;
          }
        },
        {
          keywords: ['情景剧'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，这是一个实拍情景剧完整方案：

# 情景剧：6个人，3种忌口，中午吃什么（SG001）

## 人物
- **组织者小林**：28岁行政，负责订餐
- **同事甲**：不吃香菜；**同事乙**：减脂要高蛋白；**同事丙**：预算不能超30
- **产品**：AI项目（真实录屏承接）

## 场景
办公室工位区，11:30，外卖软件打开又关掉三次。

## 脚本

**(0-5s Hook)**
小林（对着三个群聊消息抓狂）：6个人，3种忌口，2个减脂，预算还不到30——中午到底吃什么啊？

**(6-15s 冲突)**
同事乙：别又点轻食沙拉了，吃不饱。
同事甲：有香菜我一律不吃。
小林：行行行，我自己研究。（打开AI项目）

**(16-30s AI项目进入)**
小林（对AI项目说）：6个人吃饭，1个不吃香菜，2个要高蛋白，人均30以内，帮我筛几家能送到的。
（录屏：AI项目输出候选清单+理由）

**(31-45s 结果推动剧情)**
小林：它连「谁不吃什么」都记住了，直接给了一个都能吃的组合。
同事乙（凑过来看）：行啊，就这个。

**(46-55s 收口+复用理由)**
小林：下单前我再确认一遍。明天不用愁了，把我们的口味存着就行。
（字幕：商家、价格、配送以实际页面为准；下单前请确认）

## 结构与边界
- 结构：角色冲突 → 一个问题 → 输入 → 结果推动剧情 → 行动
- 一条只保留「众口难调」一个冲突
- 商品、价格、配送范围必须用投放当期真实录屏，不虚构优惠`;
          }
        },
        {
          keywords: ['口播'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，这是一个实拍口播完整脚本：

# 口播：帮爸妈叫车去博物馆（GD002）

## 基本信息
- **人物**：30岁子女，桌前实拍，手部+屏幕为主
- **形式**：实拍口播+真实UI演示
- **时长**：40秒

## 脚本

**(0-3s Hook)**
> 爸妈只跟我说「去老地方」，我怎么帮他们把车叫明白？

**(4-12s 任务展开)**
> 周末爸妈要去博物馆，他们不会复制地址，也说不清从哪个门进。我直接打开AI项目，把需求一次说清楚。

**(13-25s 操作演示)**
（真实录屏）
> 「帮我爸叫车，从家出发去市博物馆东门，上午九点半，车到了给我爸打电话。」AI项目会帮你核对目的地、规划出发时间，还能生成一条提醒消息直接发给爸妈。

**(26-35s 结果+边界)**
> 车型、价格、等待时间都以页面实时显示为准，下单前自己再确认一遍。给父母的消息里，我把上车点和车牌核对都写进去了。

**(36-40s 收口)**
> 不能陪在爸妈身边，至少把他们出门这件事安排明白。下载AI项目，试试看。

## 拍摄与合规
- 手部操作+屏幕特写，步骤字幕同步
- 录屏必须来自投放当期可用版本；脱敏个人位置信息
- 定位、联系人和代叫需用户授权；不保证车型/费用/时效；紧急情况不替代紧急服务`;
          }
        },
        {
          keywords: ['AI剧情', '数字人'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，这是一个数字人+混剪方案（AI创意方向）：

# 数字人：60秒看懂今晚为什么值得看（SJ001）

## 定位
数字人适合承载「快更新的信息」：赛程、清单、规则拆解。不伪造专家/记者/官方身份。

## 基本信息
- **角色**：数字人主持，清晰口播，信息卡统一模板
- **场景**：虚拟演播位 + 授权赛事信息卡
- **时效要求**：每条标注比赛名称、信息截止时间、自动失效时间

## 分镜结构（60秒）
**(0-5s Hook)**
数字人：「今晚8点的这场，如果你只看20分钟，看哪20分钟？」（带日期的问题开场）

**(6-20s 信息拆解)**
数字人口播+信息卡：两队近况、关键对位、一个不确定因素（明确标注「基于公开信息的娱乐性分析」）。

**(21-40s AI项目任务证明)**
（UI录屏）输入「今晚X队vsY队，给我一份观赛重点和赛前提醒」→ AI项目生成观赛清单 → 设置赛前提醒。

**(41-52s 来源与条件)**
「阵容和伤停信息截至今天下午，以官方公布为准。」数字人口播来源卡。

**(53-60s 收口)**
「设置好提醒，错过直播也能拿到一分钟赛况摘要。下载AI项目，赛前赛后都用得上。」

## 边界与风险
1. 预测只做娱乐性分析，写明不确定性；禁止「稳、必胜、内幕、命中率保证」和博彩引导
2. 比赛、集锦、解说音轨、球员肖像必须确认授权，不以「二创」替代版权许可
3. 旧赛程、旧截图重投前必须重录——过时信息直接损害信任`;
          }
        },
        {
          keywords: ['写脚本', '脚本'],
          response: (project, _conversation) => {
            return `需要什么类型的脚本？基于「${project.name}」AI拆解，五类一级素材都可以写：

1. 达人二创（真实场景+对话卡片）
2. 数字人（时效信息/清单/规则拆解）
3. 实拍情景剧（关系冲突带出任务）
4. 实拍口播（操作演示/步骤教学）
5. 混剪（结果反差/多画面快切，需授权素材）

先选「任务证明方式」再选类型：要看见真实动作→达人二创或实拍；要快更新信息→数字人或混剪；要关系代入→情景剧；要步骤清楚→实拍口播。

直接说「写实拍情景剧」「写口播」「写数字人脚本」即可。`;
          }
        },
        {
          keywords: ['第二个', '展开'],
          response: (project, conversation) => {
            const item = extractNthItem(conversation, 2);
            if (!item) {
              return '你想要展开哪一个？请告诉我序号或者名称。';
            }
            return `「${item.trim().slice(0, 30)}…」详细展开（最小可投放结构）：

【目标人群】谁，在什么时刻遇到什么问题（一个主要人群）
【一个主要问题】只能有一个
【前3秒】真实人物/动作/问题/反差
【任务证明】输入条件 → AI项目处理 → 可执行结果（至少展示两个环节）
【复用理由】用户下一次为什么还要打开（记录/追问/提醒/续讲）
【CTA】低压力、条件化，不承诺结果
【唯一测试变量】只改钩子/角色/场景/表达/UI中的一项
【动态事实核验】端、版本、地区、日期、审核人
【风险】版权、隐私、交易、健康、宠物、情感、赛事等按方向专项检查

把上面字段填完，这条素材就达到可投放标准。需要我按这个结构写完整脚本吗？`;
          }
        },
        {
          keywords: ['展开', '详细', '介绍'],
          response: (project, conversation) => {
            const item = extractNthItem(conversation, 1);
            if (!item) {
              return '你想要展开哪一个？请告诉我序号。';
            }
            return `${item.trim()}——展开说明：

基于「${project.name}」AI拆解 的执行框架：

### 人群与触发
按「细分人群 → 生活状态 → 触发时刻 → 显性痛点 → 情绪痛点 → 决策障碍」拆。${project.productUnderstanding.targetAudience}。

### 吸引机制（至少命中一项）
身份认领、即时结果、冲突反问、视觉反差、情绪共鸣、低成本试错、冷知识、时效信息、替用户完成一步。

### AI项目任务证明
必须展示「输入条件 → AI项目处理 → 可执行结果」中的至少两个环节；录屏用投放当期真实版本。

### 复用理由
回答「用户下一次什么时刻还会打开」：记录、追问、提醒、复盘、续讲、复用清单。

### 测试与合规
设置唯一测试变量；动态信息当期核验；按方向专项清单过一遍风险（健康/情感/赛事/交易/宠物）。

需要我按这个框架写完整脚本吗？`;
          }
        }
      ],
      fallbackResponse: '我理解你的问题。创意助手当前预置了素材方向、选题、演员人物、场景、脚本类回答（基于AI项目八大方向与母题库）。你可以试试快捷问题。'
    },
    editing: {
      quickPrompts: [
        '帮我拆素材结构',
        '前3秒应该怎么换？',
        '混剪应该怎么做？',
        '给我一个拼接方案',
        '帮我优化素材节奏',
        '高表现素材怎么回收二剪？'
      ],
      mockResponses: [
        {
          keywords: ['拆', '结构'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，用当期表现最好的素材给你拆结构（世界杯·数字人+混剪）：

【原素材结构】
- **0-3s**：带日期的问题开场「今晚8点的这场，如果你只看20分钟，看哪20分钟？」——时效钩子
- **3-10s**：数字人信息拆解（阵容/对位/不确定因素，信息卡同步）
- **10-25s**：AI项目任务证明：输入观赛需求 → 输出观赛清单+提醒（真实UI录屏）
- **25-45s**：赛事画面混剪提速（授权素材）+ 来源与条件说明
- **45-60s**：复用理由「设置提醒，赛后拿一分钟摘要」+ CTA下载

【为什么这条能跑】（当期 6477.27消耗/181激活/成本35.79）
1. 时效钩子精准筛人群（球迷+时间焦虑）
2. AI项目进入点自然（赛前提醒是真实任务）
3. 有复用理由（赛后摘要），不是一次性猎奇

【建议保留】
带日期的问题式开场、AI项目任务录屏段、来源卡。

【建议替换】
赛事画面每次重投前必须重核版权与时效；旧赛程截图直接下线。`;
          }
        },
        {
          keywords: ['前3秒', '开头'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，前3秒的吸引机制清单（至少命中一项）：

1. **身份认领**：「独居的、加班到十点的，这条是给你的」
2. **即时结果**：先给结果画面，再回头讲怎么做到
3. **冲突反问**：「她只回了一个嗯，我该怎么接？」
4. **视觉反差**：改造前后、生成前后对比
5. **情绪共鸣**：真实情绪瞬间（深夜、想家、吵架后）
6. **低成本试错**：「反正不要钱，问一下又不亏」
7. **冷知识**：「猫抓沙发不是报复，是环境问题」
8. **时效信息**：「今晚8点，只看这20分钟」（带日期）
9. **替用户完成一步**：直接把清单/方案甩在画面上

【替换规则】
1. 前3秒必须和方向、人群对齐：健身内容首屏出现真实动作，不要先讲「AI很强」
2. 钩子必须能接住：前3秒的问题，3-8秒内必须进入AI项目任务，不能只堆好奇
3. 一次性猎奇钩子（性别转换/神奇生成）必须绑定「下一次使用」的理由，否则次留会很难看（历史：性别转换次留12.23%最低）`;
          }
        },
        {
          keywords: ['混剪'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，混剪的做法与边界：

【混剪的适用任务】
节点热点、赛后复盘、旅行氛围、前后对比、素材回收——本质是「快速展示变化和多画面信息」。

【标准结构】
结果/反差开场 → 多画面信息流 → 统一字幕 → UI/结论卡收口。

【怎么做】
1. **先定叙事线**：一段混剪只讲一条线（时间线/对比线/步骤线），不要三线混切
2. **节奏锚点**：每2-3秒一个信息点，字幕卡承担关键数字
3. **UI模块**：AI项目的输入和结果录屏作为「证明模块」嵌入，至少展示输入和结果两个环节
4. **统一规格**：字幕字体、信息卡模板、BGM风格固定，形成可复用模板

【边界（红线）】
1. 音乐、体育、影视、图片素材均需授权；镜头来源必须可追溯
2. 赛事、优惠、路线等动态画面重投前必须重录
3. 不用盗播和侵权片段填充节奏`;
          }
        },
        {
          keywords: ['拼接'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，给你一个拼接方案：

【推荐拼接：达人原声 + AI项目证明模块 + 现实收口】
- **0-3s**：达人真实问题/动作瞬间（保留达人原声，原生感开场）
- **3-8s**：达人自然转向AI项目：「我问了下AI项目……」
- **8-20s**：AI项目UI录屏模块：输入条件 → 处理 → 可执行结果（真实当期版本）
- **20-30s**：回到达人，按AI项目的结果执行（现实动作收口）
- **30-35s**：复用理由一句 + 低压力CTA

【拼接三原则】
1. **原生感不断**：达人段落保留原声和口语，不重配音
2. **证明模块可核验**：UI录屏显示与口播一致的入口、文字、结果；用户信息脱敏
3. **授权台账**：达人原片授权范围、剪辑版本、投放生命周期登记在册；未授权素材禁止进入回收库

【适用】
这是现有素材样本里最成熟的结构（达人二创为主），也是历史复盘达人线次留更高（18.57%）的内容基础。`;
          }
        },
        {
          keywords: ['节奏'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，素材节奏按漏斗诊断优化：

【漏斗节奏表】
| 阶段 | 看什么 | 常见问题 | 优先动作 |
|------|--------|----------|----------|
| 曝光（0-3s） | 首帧、3秒率、负反馈 | 人群不识别，钩子错位 | 只改首帧/第一句/画面冲突 |
| 承接（3-25s） | 5秒、25%、完播 | 产品进入过晚、问题没升级 | 提前功能证明，调整结构 |
| 行动（CTA段） | CTR、激活、成本 | 用户没理解能做什么 | 优化任务条件、CTA和真实UI |
| 留存（投放后） | 次留、7留、评论 | 只有一次好奇 | 加记录、追问、提醒、续讲 |

【节奏红线】
1. 每条素材必须展示「输入、处理、结果」中至少两个环节——只放神奇答案的剪法上限6.9分
2. 产品进入点：内容型素材不晚于25秒；超过30秒未出现产品，这条的目标就是完播而非转化
3. 一条只保留一个核心冲突，剧情不能压过产品任务

【历史教训】
3-6月留存跌到13%的复盘结论：只做一次性炫技、只靠强身份钩子或产品进入过晚，都会让激活与次留脱钩。`;
          }
        },
        {
          keywords: ['回收', '二剪', '高表现'],
          response: (project, _conversation) => {
            return `基于「${project.name}」AI拆解，高表现素材的回收与二剪流程：

【回收流程】
1. 按当期门槛标记高表现素材（消耗、激活成本、次留综合判断）
2. 下载原始授权视频、工程文件、脚本、字幕、UI版本和数据快照
3. 标注胜出模块：首帧、第一句、人物关系、问题、UI、结果、字幕、节奏、BGM
4. 按「方向—人群—主题—形式—胜出模块」入库

【二剪规则】
1. 每个新版本只保留 1-2 个胜出模块，替换一个变量
2. 动态信息（旧优惠、旧赛程、旧价格、旧路线）重投前必须重新录制
3. 未授权或含个人敏感信息的素材禁止进入回收库
4. 结论写回时标注证据等级（A多账户一致 / B单账户多素材 / C单条 / D假设），禁止把C级经验写成已验证规律

【单变量矩阵示例】
同一「帮父母叫车」脚本：只换钩子（语音叫车 vs 核对清单 vs 费用澄清）三版，其余帧一致，观察3秒率和激活成本。`;
          }
        }
      ],
      fallbackResponse: '我理解你的问题。后期助手当前预置了素材结构、混剪、拼接、节奏、素材回收类回答（基于AI项目素材分析报告）。你可以试试快捷问题。'
    }
  }
};
